<template>
  <div>
    <div class="form-group position-relative">
      <label :for="id" class="glass-label">
        {{ label }}
        <span class="text-white-muted fs-7 fst-italic">(Format <b>#RRGGBB</b>)</span>
      </label>
      <input
        :id="id"
        v-model="insideColorChoice"
        class="glass-input color-picker-input"
        :type="type"
        :placeholder="placeholder"
        :required="required"
        :aria-required="required"
        :aria-describedby="`${id}-format-desc`"
        maxlength="7"
        pattern="^#[0-9A-Fa-f]{6}$"
        @input="validateHexInput"
      />

      <div class="position-absolute end-0 me-2" style="top: 54%">
        <color-picker
          v-model:pureColor="insideColorChoice"
          format="hex"
          picker-type="chrome"
          use-type="pure"
          :disable-alpha="true"
          :disable-history="true"
          aria-label="Sélecteur de couleur"
        >
          <template #extra>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="glass-btn-success rounded-5 py-2 px-3"
                @click="closeColorPicker"
              >
                Valider
              </button>
            </div>
          </template>
        </color-picker>
      </div>
    </div>

    <!-- Couleurs par défaut -->
    <div class="default-colors-container mt-2 mb-2">
      <button
        v-for="defaultColor in defaultColors"
        :key="defaultColor"
        type="button"
        class="color-swatch"
        :style="{ backgroundColor: defaultColor }"
        :class="{ active: insideColorChoice === defaultColor }"
        :aria-label="`Sélectionner la couleur ${defaultColor}`"
        @click="selectDefaultColor(defaultColor)"
      />
    </div>
  </div>
</template>

<script>
import { ColorPicker } from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'

export default {
  name: 'ColorpickerComponent',
  components: {
    ColorPicker
  },

  props: {
    id: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:color'],

  data() {
    return {
      insideColorChoice: this.color,
      defaultColors: ['#FF5252', '#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#E91E63']
    }
  },

  watch: {
    insideColorChoice(newColor) {
      this.$emit('update:color', newColor)
    },
    color: {
      handler(newColor) {
        this.insideColorChoice = newColor
      },
      immediate: true
    }
  },

  methods: {
    validateHexInput(event) {
      let value = event.target.value

      // Assurer que la valeur commence par #
      if (!value.startsWith('#')) {
        value = '#' + value.replace('#', '')
      }

      // Supprimer tous les caractères non-hexadécimaux (sauf le #)
      value = '#' + value.slice(1).replace(/[^0-9A-Fa-f]/g, '')

      // Limiter à 7 caractères maximum
      if (value.length > 7) {
        value = value.slice(0, 7)
      }

      this.insideColorChoice = value
    },

    selectDefaultColor(color) {
      this.insideColorChoice = color
    },

    closeColorPicker() {
      document.body.click()
    }
  }
}
</script>

<style scoped>
::placeholder {
  color: var(--c-white);
  opacity: 0.8;
  font-style: italic;
}

.default-colors-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.color-swatch {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-swatch:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.color-swatch.active {
  border-color: var(--c-white, #ffffff);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  transform: scale(1.05);
}

@media (max-width: 576px) {
  .color-swatch {
    width: 40px;
    height: 40px; /* cible tactile plus proche de 44px, était 30px */
  }
}
</style>
